import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UserBlockAnswers } from '../../../../../../config/api/models/Answers';
import GroupAnswers from './GroupAnswers';
import StudentAnswers from './StudentAnswers';
import { Exercise } from '../../../../../../config/api/models/Exercise';
import { Solution } from '../../../../../../config/api/models/Solutions';
import { AnswersContentWrapper, ExerciseLabel } from './Atoms';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type Props = {
  exercise: Exercise;
  groupAnswersFromPage?: UserBlockAnswers[];
  userAnswersFromPage?: UserBlockAnswers;
  solution?: Solution;
};

const Answers: FC<Props> = ({ exercise, groupAnswersFromPage, userAnswersFromPage, solution }) => {
  const { t } = useTranslation();
  const activeFilter = useAppSelector((state) => state.filters.activeFilter);
  const selectedStudent = useAppSelector((state) => state.filters.selectedStudent);

  return !!activeFilter ? (
    <>
      {(!!groupAnswersFromPage || selectedStudent !== '') && (
        <>
          <AnswersContentWrapper>
            {selectedStudent === '' && groupAnswersFromPage ? (
              <GroupAnswers data={groupAnswersFromPage} />
            ) : (
              <StudentAnswers exercise={exercise} data={userAnswersFromPage} solution={solution} />
            )}
          </AnswersContentWrapper>
          <ExerciseLabel>{t('trajectory.sections.shared.exercise')}:</ExerciseLabel>
        </>
      )}
    </>
  ) : null;
};

export default Answers;
